import BaseVueComponent from "common/BaseVueComponent"
import { Component, Prop } from "vue-property-decorator"

@Component
export default class FAppBarBase extends BaseVueComponent {
    @Prop(String) public title!: string
    @Prop(Boolean) public dark!: boolean
}
